import React, {Component} from 'react';
import Api from "../../utils/Api";
import PropTypes from "prop-types";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import DesignSmall from './DesignSmall';
import DesignMedium from './DesignMedium';
import DesignTable from './DesignTable';
import ModuleNav from "../../mainFrame/ModuleNav";
import SortSelector from "../../utils/SortSelector";
import StaticFunctions from "../../utils/StaticFunctions";
import Timeformat from "../../utils/Timeformat";
import SearchField from "../../utils/SearchField";
import DesignPreviewContainer from "../../utils/DesignPreviewContainer";
import PagingContainer from "../../utils/PagingContainer";


class DesignContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            activeView: 'smallView',
            filterString: '',
            requestedParams: null,
            designs: null,
            filteredDesigns: null,
            currentPage: 0,
            maxEntries: 60,
            sortSelected: null,
            sortOrder: 'asc'
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.requestDesigns = this.requestDesigns.bind(this);
        this.setSorter = this.setSorter.bind(this);
        this.resetSorter = this.resetSorter.bind(this);
        this.handleViewChange = this.handleViewChange.bind(this);
        this.setModalContent = this.setModalContent.bind(this);
        this.initSearch = this.initSearch.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.setPage = this.setPage.bind(this);

    };

    componentWillMount() {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const state = {...this.state};

        //  View aus den userprops laden
        const activeView = (settings.viewDesigns) ? settings.viewDesigns : 'smallView';

        if (activeView) state.activeView = activeView;

        this.setState(state, this.requestDesigns);

    }

    requestDesigns() {

        const params = {
            id_company: this.props.baseData.companies.currentCompany.id,
            maxRows: this.state.maxEntries,
            offset: this.state.maxEntries * this.state.currentPage
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    designs: res,
                    filteredDesigns: res,
                }, this.initSearch);
            }
        }.bind(this);

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return;

        this.setState({
            requestedParams: sParams
        });

        this.api.request('GetDesigns', params, callback);

    }

    handleViewChange(view) {

        this.props.baseData.saveSettings('viewDesigns', view);

        this.setState({activeView: view});

    }

    initSearch() {

        this.onSearch('searchDesign', this.state.filterString);

    }

    onSearch(name, value) {

        const designs = (this.state.designs) ? this.getSortedData([].concat(this.state.designs)) : [];
        const filteredDesigns = StaticFunctions.getFilteredData(designs, value, ['id', 'name']);

        this.setState({
            filterString: value,
            filteredDesigns,
            currentPage: 0
        });

    }

    setSorter(value) {

        if (value !== this.state.sortSelected) {
            this.setState({
                sortSelected: value,
            });
        }

    }

    resetSorter() {

        this.setState({
            sortSelected: null,
        });

    }

    setModalContent(id) {

        if (!id) return null;

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const design = this.getDesignById(id);
        const styles = {height: '600px'};
        const dateInserted = (design) ? Timeformat.fromUnix(design.date_inserted).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

        const content = (
            <table style={{width: '100%'}}>
                <tbody>
                    <tr>
                        <td className="text-center" colSpan="2">
                            <DesignPreviewContainer baseData={this.props.baseData} designId={design.id} designStitches={design.stitches} styles={styles}/>
                        </td>
                    </tr>

                    <tr>
                        <td className="text-right" style={{cursor: 'default', padding: '0 5px'}}>{this.translate('designId')}</td>
                        <td className="text-left" style={{cursor: 'default', padding: '0 5px'}}>{design.id}</td>
                    </tr>

                    <tr>
                        <td className="text-right" style={{cursor: 'default', padding: '0 5px'}}>{this.translate('designName')}</td>
                        <td className="text-left" style={{cursor: 'default', padding: '0 5px'}}>{design.name}</td>
                    </tr>

                    <tr>
                        <td className="text-right" style={{cursor: 'default', padding: '0 5px'}}>{this.translate('designStitches')}</td>
                        <td className="text-left" style={{cursor: 'default', padding: '0 5px'}}>{StaticFunctions.formatedNumber(design.stitches)}</td>
                    </tr>

                    <tr>
                        <td className="text-right" style={{cursor: 'default', padding: '0 5px'}}>{this.translate('dateInserted')}</td>
                        <td className="text-left" style={{cursor: 'default', padding: '0 5px'}}>{dateInserted}</td>
                    </tr>
                </tbody>
            </table>
        );

        this.props.baseData.modalData({
            content: content
        });

    }

    getDesignById(id) {

        if (this.state.filteredDesigns) {
            const designs = this.state.filteredDesigns;

            for (let i = 0; i < designs.length; i++) {
                if (designs[i].id === id) {
                    return designs[i];
                }
            }
        }

        return null;
    }

    getSortOptions() {

        return [
            {
                value: 'id',
                label: this.translate('designId')
            },
            {
                value: 'name',
                label: this.translate('designName')
            },
            {
                value: 'stitches',
                label: this.translate('designStitches')
            },
            {
                value: 'dateInserted',
                label: this.translate('dateInserted')
            },
        ];

    }

    getSortedData(designs) {

        if (!this.state.sortSelected) return designs;

        const column = this.state.sortSelected.value;
        const order = this.state.sortOrder;
        const type = this.state.sortSelected.sortType;

        return StaticFunctions.getSortedData(designs, column, type, order);

    }

    nextPage() {

        this.setPage(this.state.currentPage + 1);

    }

    prevPage() {

        this.setPage(this.state.currentPage - 1);

    }

    setPage(pageNumber) {

        const minPage = 0;
        const maxPage = (this.state.filteredDesigns.length > 0) ? (Math.ceil(this.state.filteredDesigns.length / this.state.maxEntries) - 1) : 1;

        let currentPage = pageNumber;

        if (pageNumber < minPage) currentPage = maxPage;
        if (pageNumber > maxPage) currentPage = minPage;

        this.setState({currentPage: currentPage});

    }

    renderView() {

        if (this.state.designs === null || this.state.filteredDesigns === null) return <LoadingSplash color={'dark'}/>;

        const {maxEntries, currentPage} = {...this.state};

        const displayFrom = currentPage * maxEntries;
        const displayTo = displayFrom + maxEntries;

        const designs = ((this.state.filteredDesigns) ? [].concat(this.state.filteredDesigns) : []).slice(displayFrom, displayTo);
        const designLength = (this.state.filteredDesigns) ? this.state.filteredDesigns.length : 0;

        if (designs) {
            const activeView = this.state.activeView;

            if (activeView === 'smallView') {
                return <DesignSmall
                    data={this.getSortedData(designs)}
                    baseData={this.props.baseData}
                    onClick={this.setModalContent}
                />;
            } else if (activeView === 'mediumView') {
                return <DesignMedium
                    data={this.getSortedData(designs)}
                    baseData={this.props.baseData}
                    onClick={this.setModalContent}
                />;
            } else if (activeView === 'tableView') {
                return <DesignTable
                    data={designs}
                    baseData={this.props.baseData}
                    designCounter={designLength}
                    onClick={this.setModalContent}
                />;
            } else {
                return this.translate('noViewFound');
            }
        }

        return this.translate('noDesignFound');

    }

    render() {

        const archivAreaClasses = ['archivArea', this.state.activeView].join(' ').trim();
        const viewArea = this.renderView();

        const designs = this.state.filteredDesigns || [];

        return (
            <div>
                <nav>
                    <h1>{this.translate('designs')}</h1>

                    <ModuleNav
                        translate={this.translate}
                        activeView={this.state.activeView}
                        onClick={this.handleViewChange}
                    />

                    <SortSelector
                        options={this.getSortOptions()}
                        selected={this.state.sortSelected}
                        activeView={this.state.activeView}
                        translate={this.translate}
                        onClick={this.setSorter}
                    />

                    <SearchField
                        baseData={this.props.baseData}
                        name="searchDesign"
                        placeholder={this.translate('searchForIdOrName')}
                        onSearch={this.onSearch}
                    />
                </nav>

                <PagingContainer
                    items={designs.length}
                    currentPage={this.state.currentPage}
                    itemsPerPage={this.state.maxEntries}
                    changePage={this.setPage}
                />

                <div className={archivAreaClasses}>
                    <div className="fadeInArea clearfix">
                        {viewArea}
                    </div>
                </div>

                <PagingContainer
                    items={designs.length}
                    currentPage={this.state.currentPage}
                    itemsPerPage={this.state.maxEntries}
                    changePage={this.setPage}
                />

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('analysis')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default DesignContainer;
